// removed by extract-text-webpack-plugin
module.exports = {"columns":"index__columns___2CyV_","columnOne":"index__columnOne___1QW0M","columnTwo":"index__columnTwo___6tg6L","fadein":"index__fadein___2j7FJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/splitview/index.scss
// module id = 396
// module chunks = 0